import BookieLogo, { LOGO_SIZE } from '@cx-web/components/primitives/bookie-logo';
import OCButton from '@cx-web/components/primitives/button';

import { type BookieOdds, useBetslipContext } from '~/providers/betslip-context';
// providers
import { useServicesContext } from '~/providers/services-context';
// services
import { TRACKING_ACTIONS, TRACKING_CATEGORIES, TRACKING_EVENTS } from '~/services/actions/tracking-actions';

import ClickoutBetslip from '../icons/clickout';
// styles
import styles from '../style/bookie-selection.module.css';
import FormatCurrency from '../util/format-currency';

import { StakeInput } from './stake-input';

const BookieSelection = ({
  selected,
  selectedBookie



}: {selected?: boolean;selectedBookie: BookieOdds;}): JSX.Element => {
  const { labelActions, siteConfig, trackingActions } = useServicesContext();

  const { getOdds, handleClickoutToPlaceBet, selectBookie, stake, userOddsFormat } = useBetslipContext();

  const returns = (() => {
    const r = selectedBookie.oddsDecimal * stake;
    return r.toFixed(r > 100 ? 0 : 2);
  })();

  function renderStake() {
    if (selected) {
      return <StakeInput returns={<FormatCurrency value={returns} />} stake={stake} />;
    }

    return (
      <>
        <div className={styles.sectionWrapper}>
          <div className={styles.title}>{labelActions.get('STAKE')}:</div>
          <div className={styles.number}>
            <FormatCurrency value={stake} />
          </div>
        </div>
        <div className={styles.sectionWrapper}>
          <div className={styles.title}>{labelActions.get('RETURNS')}:</div>
          <div className={styles.number}>
            <FormatCurrency value={returns} />
          </div>
        </div>
      </>);

  }

  const handleClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    trackingActions.eventTracking({
      event: TRACKING_EVENTS.BET_SLIP_SIGN_UP,
      eventCategory: TRACKING_CATEGORIES.BETTING,
      eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.BET_SLIP_SIGN_UP],
      eventLabel: selectedBookie.bookmakerCode
    });
    handleClickoutToPlaceBet(selectedBookie);
  };

  function renderButton(): JSX.Element {
    if (selected) {
      return (
        <OCButton className={styles.button} disabled={!stake} onClick={handleClick}>
          <ClickoutBetslip />
          {labelActions.get('BET')}
        </OCButton>);

    }

    return (
      <OCButton className={styles.signUpButton} onClick={handleClick}>
        <ClickoutBetslip />
        {labelActions.get('SIGN_UP')}
      </OCButton>);

  }

  const handleBookieSelectionClick = () => {
    if (!selected && typeof selectedBookie.index !== 'undefined') selectBookie(selectedBookie.index);
  };

  return (
    <div className={[styles.bookieSelection, selected ? styles.selected : ''].join(' ')} role="button">
      <BookieLogo
        bookieCode={selectedBookie.bookmakerCode}
        bookmakers={siteConfig.bookmakers}
        className={styles.bookieLogo}
        onClick={handleBookieSelectionClick}
        size={LOGO_SIZE.SMALL} />

      <div className={styles.sectionWrapper}>
        <div className={styles.title}>{labelActions.get('ODDS')}:</div>
        <div className={styles.odds}>{getOdds(selectedBookie, false, userOddsFormat)}</div>
      </div>
      {renderStake()}
      {renderButton()}
    </div>);

};

export default BookieSelection;